export function polarPoint(cx, cy, r, angleDeg) {
  const rad = (angleDeg * Math.PI) / 180
  return {
    x: cx + r * Math.sin(rad),
    y: cy - r * Math.cos(rad),
  }
}

export const ANGLES_12 = Array.from({ length: 12 }, (_, i) => i * 30)
